<template>
  <div class="columns is-fullheight is-marginless">
    <aside class="menu has-background-admin-primary column is-2 has-text-left">
      <p class="menu-label" v-t="'Admin.Menu.administration_title'"></p>
      <ul class="menu-list">
        <router-link to="/dashboard" exact>
          <li v-t="'Admin.Menu.statistics'"></li>
        </router-link>
        <li>
          <p class="menu-label" v-t="'Admin.Menu.pages'">
          </p>
          <ul>
            <router-link to="/dashboard/pages/home" v-t="'Admin.Menu.pages_home'"></router-link>
          </ul>
        </li>
        <router-link to="/dashboard/capsules">
          <li v-t="'Admin.Menu.capsules'"></li>
        </router-link>
        <router-link to="/dashboard/collections">
          <li v-t="'Admin.Menu.collections'"></li>
        </router-link>
        <router-link to="/dashboard/partners">
          <li v-t="'Admin.Menu.partners'"></li>
        </router-link>
      </ul>
    </aside>
    <div class="column is-10 is-paddingless" style="background-color:#f2f2f2">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
/* import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { Quill, quillEditor } from 'vue-quill-editor'
import ImageResize from 'quill-image-resize-module' */

import { mapState } from 'vuex'
import FormLanguageBar from '@/components/FormLanguageBar'
export default {
  components: {
    FormLanguageBar
  },
  data () {
    return {
      isCreating: false
    }
  },
  mounted () {
    this.$store.dispatch('getForm')
    this.$store.dispatch('fetchCapsules')
  },
  computed: {
    ...mapState({
      form: state => state.Api.form,
      isLoadingCapsules: state => state.Api.pending.capsules,
      isLoadingForm: state => state.Api.pending.form,
      errorLoadingForm: state => state.Api.error.form,
      isCreatingCapsule: state => state.Api.pending.createCapsule,
      errorCreatingCapsule: state => state.Api.error.createCapsule
    })
  },
  methods: {
    isActive: function (item) {
      return this.selectedMenu === item
    },
    requestCapsuleData: function (capsuleId) {
      this.$store
        .dispatch('getCapsule', { params: { id: capsuleId } })
        .then(() => {})
        .catch(() => {})
    },
    onEditorChange ({ quill, html, text }) {
      this.content = html
    }
  }
}
</script>

<style lang="sass">
@import "src/sass/msteam-style"
@import 'src/sass/dashboard-style'
@import '~bulma/bulma'
</style>

<style scoped lang="sass">
@import 'src/sass/dashboard-style'
@import '~bulma/bulma'
@import '~bulma/sass/utilities/mixins'
$navbar-height: 3.5rem

.columns
+tablet
  &.is-fullheight
    min-height: calc(100vh - ( #{$navbar-height} + .5rem ) )
    max-height: calc(100vh - ( #{$navbar-height} + 0.1rem ) )
    height: calc(100vh - ( #{$navbar-height}+ 0rem ) )
    display: flex
    flex-direction: row
    justify-content: stretch
    .column
      overflow-y: auto

.fade-enter-active,
.fade-leave-active
  transition: opacity 0.5s;

.fade-enter,
.fade-leave-to
  opacity: 0;

.menu
  padding-top: 50px;

th,
tr,
td
  border: 1px solid grey;

th
  text-align: center !important;

</style>
